import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {
        template,
        request: {url, urlIsSaleOrClearance},
        search: {enableCentreTitle, breadcrumbs},
    } = state

    return {
        enableCentreTitle,
        breadcrumbs,
        url,
        templating: template,
        urlIsSaleOrClearance,
    }
}

export default connect(mapStateToProps)
